import { useNavigate } from 'react-router-dom';
import { Progress } from './ui/progress';
import { Button } from './ui/button';
import { Course } from '../interfaces/course';

interface CourseCardProps {
  course: Course;
}

export function CourseCard({ course }: CourseCardProps) {
  const navigate = useNavigate();

  const progress =
    course.total_levels > 0
      ? (course.completed_levels / course.total_levels) * 100
      : 0;
  const isCompleted = course.status === 'Completed';

  const handleCourseClick = () => {
    navigate(`/courses/${course.course_id}`);
  };

  return (
    <div className="mb-6">
      <div className="bg-white rounded-3xl shadow-sm overflow-hidden">
        <div className="p-5">
          <div className="flex items-center mb-6">
            <div className="w-14 h-14 rounded-full bg-bg-chat overflow-hidden flex items-center justify-center mr-4">
              <img
                src="/images/llaami.svg"
                alt="Course Icon"
                className="w-8 h-8"
              />
            </div>
            <div>
              <h3 className="font-bold text-title text-lg">
                {course.course_name}
              </h3>
              <p className="text-sm text-subheading">
                {course.department_name}
              </p>
            </div>
          </div>

          <div className="mb-4">
            <div className="flex justify-between text-sm mb-2">
              <span className="text-subheading">Progress</span>
              <span className="font-medium text-title">
                {Math.round(progress)}%
              </span>
            </div>
            <Progress value={progress} />
            <p className="text-xs text-subheading mt-2">
              {course.completed_levels} of {course.total_levels} levels
              completed
            </p>
          </div>

          <Button
            onClick={handleCourseClick}
            className="w-full rounded-full bg-accent-purple hover:bg-accent-purple/90 text-white py-6 h-12 mt-2"
          >
            {isCompleted ? 'Review Course' : 'Continue Learning'}
          </Button>
        </div>
      </div>
    </div>
  );
}
